import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import ExternalMapLiveRoute from 'garaje/pods/maps-external-live/route';

export default class MapsExternalDraftRoute extends ExternalMapLiveRoute {
  @service declare router: RouterService;

  controllerName = 'maps-external-live';
  templateName = 'maps-external-live';
}
